import React, { createContext, useContext, useState } from 'react';

const ModalContext = createContext(null);

export const useModal = () => {
  return useContext(ModalContext);
};

export const ModalProvider = ({ children }) => {
  const [modalType, setModalType] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [props, setProps] = useState({});

  const openModal = param => {
    setModalType(param.modalName);
    setProps(param.modalData);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setModalType(null);
    setIsModalOpen(false);
  };

  return (
    <ModalContext.Provider value={{ modalType, isModalOpen, openModal, closeModal, props }}>
      {children}
    </ModalContext.Provider>
  );
};